import { FileTextOutlined } from '@ant-design/icons';
import UserInfo from 'components/ui/user-info';
import {
  SubmissionResponseDto,
  SubmissionResponseDtoStatusEnum,
} from 'libs/pinnacle-sdk';
import CustomBadge from '../custom-badge';
import { useTranslation } from 'react-i18next';

interface SubmissionHeaderProps {
  submission: SubmissionResponseDto;
  onStatusClick?: () => void;
}

const SubmissionHeader = ({
  submission,
  onStatusClick,
}: SubmissionHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between py-4">
      {/* Left side */}
      <div>
        <div className="flex gap-2 items-center">
          <span className="text-[#5e6b7c] text-sm">
            {t('submission.submissionId')}:
          </span>
          <span className="text-[#1d67b6] font-medium">
            {submission.submissionId}
          </span>
        </div>
        <h1 className="text-2xl font-semibold text-[#010d1d] mt-1">
          {submission.insured?.name || '-'}
        </h1>
      </div>

      {/* Right side */}
      <div className="flex flex-col gap-4 items-end">
        <div className="flex gap-4 items-start">
          <button className="flex items-center gap-2 px-6 py-2 shadow-md bg-[#1d67b6] text-white rounded-lg hover:bg-[#1d67b6]/90 transition-colors">
            <FileTextOutlined />
            <span>{t('submission.documents')}</span>
          </button>
          <div className="flex flex-col items-end">
            <div>{t('submission.assignedHandler')}:</div>
            <UserInfo name={submission.assignedHandler?.name || '-'} />
          </div>
        </div>
        <div className="flex gap-2 items-center">
          {t('submission.submissionStatus')}:
          <CustomBadge
            label={submission.status}
            onClick={onStatusClick}
            backgroundColor="bg-blue-100"
            textColor="text-blue-600"
          />
        </div>
      </div>
    </div>
  );
};

export default SubmissionHeader;
